var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{staticClass:"breadcrumbG letter-big",attrs:{"items":_vm.itemsTranslations}})
}
var staticRenderFns = []

export { render, staticRenderFns }